var api = "https://api.qingcigame.com";
var initialSlide = 0;

// 部分文章添加下载按钮跳转功能
let jsonDataId = [{
        id: 599,
        picture: 'https://download4.qcplay.com/qcgame-admin/4wNZhMp8bdNneQJgbmZm7lNOUjZrLaHmOhKB42Df.png',
        downloadBtn: 'https://download4.qcplay.com/qcgame-admin/XonzPTrQ9SY8ET6EuW5cpkmXvVv0hlWZ7mOXWyoK.png',
        downloadUrl: '//download2.qcplay.com/zd/apk/launcher-release.apk',
    },
    // {
    //     id: 600,
    //     picture: 'https://download4.qcplay.com/qcgame-admin/3NnBlizsuly5G0LI7NpBj4KptBs5KWl3av0KCrUX.png',
    //     downloadBtn: 'https://download4.qcplay.com/qcgame-admin/fESWYDdnz7anFUL0coVDKX7lR42bjAbakt24S6de.png',
    //     downloadUrl: 'http://download2.qcplay.com/zd/apk/launcher-release.apk',
    // }
]

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                }
            }
        };
        getRequest();
        // console.log('initialSlide', initialSlide)
        // this.preloading();          // 预加载
        this.indexSwiper(); // 首页大轮播
        this.share();
        this.indexBind();
    },
    // 新闻列表
    newsList: function() {
        var cate_id, page, current, index;
        this.newsZxList(); // 新闻最新列表
        this.newsTabPage(); // 最新、综合、活动跳转
        this.share();
    },
    // 新闻详情
    newsDetails: function() {
        this.newsInfo(); // 新闻详情
        this.share();
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();
            setTimeout(function() {
                $('.top-clouds').addClass('top-clouds-ani');
                $('.bg').addClass('bg-ani');
            }, 500)
            setTimeout(function() { $('.top-clouds').remove() }, 3000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/charity/images/pc/m_dt_sz.png',
            '//static.qcplay.com/snail/charity/images/pc/m_dt_t.png',
            '//static.qcplay.com/snail/charity/images/pc/m_jdt.png',
        ]);
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(document).height();
            var windowHeight = $(this).height();
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    slidePage: function() {
        $('')
    },
    // 首页轮播
    indexSwiper: function() {
        // var change_deg = 60; 
        var change_deg = 180; // 若2个为60 - 6个为300，每次递增60
        var mySwiper = new Swiper(".global-promotion", {
            pagination: '.swiper-pagination',
            paginationClickable: true,
            slidesPerView: 1,
            initialSlide: initialSlide,
            // speed: 100,
            // slidesOffsetAfter: .115 * document.body.clientWidth,
            watchSlidesProgress: !0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function(swiper1) {
                    swiperAnimateCache(this); //隐藏动画元素 
                    swiperAnimate(this); //初始化完成开始动画
                    $('.global-01').addClass('global-ani')
                    const _this = this;

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            _this.slideTo(page, 1000, true);
                        });
                    };

                    function navLink() {
                        for (var i = 3; i >= 0; i--) {
                            Ani('.nav-link-0' + i + ' .link-a', i);
                        };
                    }
                    navLink();
                },
                onSlideChangeEnd: function() {

                },
                slideChangeTransitionStart: function() {
                    if (this.activeIndex === 0) {
                        $(".global-circle").css("z-index", "11")
                        $(".global-01").css("z-index", "11")
                            // $(".swiper-button-next, .swiper-button-prev").hide()
                    } else {
                        $(".global-01").css("z-index", "0")
                        $(".global-circle").css("z-index", "0")
                            // $(".swiper-button-next, .swiper-button-prev").show();
                    }
                },
                slideChangeTransitionEnd: function() {
                    swiperAnimate(this);
                    $('.nav-link').removeClass('on')
                        // console.log(this.activeIndex);
                    $('.nav-link-0' + this.activeIndex + '').addClass('on');
                    if (this.activeIndex !== 0) {
                        $('.index .header').fadeIn();
                    } else {
                        $('.index .header').hide();
                    }
                    var indexX = this.activeIndex + 1;
                    $('.global-0' + indexX + '').addClass('global-ani').siblings().removeClass('global-ani');
                },
                touchMove: function(mySwiper) {
                    deg = change_deg * this.progress;
                    this.$el.parents(".global").find(".global-circle").transform("rotate(-" + deg + "deg)")
                },
                setTransition: function(a) {
                    deg = change_deg * this.progress;
                    this.$el.parents(".global").find(".global-circle").transition(a).transform("rotate(-" + deg + "deg) translate3d(0, 0, 0)")
                },
                slidePrevTransitionEnd: function() {
                    // console.log('pre');
                },
                slideNextTransitionEnd: function() {
                    // console.log('next');
                },
            },
        });
        $('.school_btn').on('click', function() {
            mySwiper.slideTo(1, 300);
        })
        $('.life_btn').on('click', function() {
            mySwiper.slideTo(2, 300);
        })
        $('.farm_btn').on('click', function() {
            mySwiper.slideTo(3, 300);
        })
    },
    // 新闻最新接口
    newsZxList: function() {
        cate_id = this.getQueryVariable('cate_id');
        page = this.getQueryVariable('page');
        current = window.location.href.split("?")[0];
        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.news .tab-title .a-tab-0' + cate_id + '').addClass('on').siblings('a').removeClass('on');
        $.ajax({
            url: "https://api.qcplay.com/web/article?area=4",
            type: "GET",
            data: {
                // cate_id 最新-综合-活动
                // page    1...
                cate_id: cate_id,
                page: page,
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var current_page = json.data.articleList.current_page; // 当前页数
                    var last_page = json.data.articleList.last_page; // 总共页数
                    var prev_page_url = json.data.articleList.prev_page_url; // 前一页
                    var next_page_url = json.data.articleList.next_page_url; // 后一页

                    // 渲染列表
                    $.each(json.data.articleList.data, function(index, values) {
                        var dtHtml = `<li>
                                <a title="${values.article_title}" href="news-details.html?id=${values.id}">
                                    <div class="news-image">
                                        <img src="${values.thumbnail}">
                                    </div>
                                    <em></em>
                                    <p class="lside">
                                        <span class="title">${values.article_title}</span>
                                        <span class="comment">${values.article_excerpt}</span>
                                    </p> 
                                </a> 
                            </li>`;
                        $('.new-list ul').append(dtHtml);
                    });
                    $('.current_page').html(current_page); // 当前页数
                    $('.last_page').html(last_page); // 总共页数
                    if (prev_page_url === null) { // 上一页
                        $('.front-link').hide(); // 没有第一页
                    } else {
                        $('.front-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + prev_page_url.split("?page=")[1])
                    }
                    if (next_page_url === null) { // 下一页
                        $('.after-link').hide(); // 没有最后一页
                    } else {
                        $('.after-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + next_page_url.split("?page=")[1])
                    }
                    $('.new-list').addClass('new-list-show');
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.news .tab-title').on('click', 'a', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });


        cate_id = this.getQueryVariable('cate_id');
        if (cate_id == 37) {
            $('.a-tab-01').addClass('on').siblings().removeClass('on');
            $('.nav-link').removeClass('on');
            $('.nav-link-01').addClass('on');
            $('.change_a').html("蜗牛学村").attr("href", "news-list.html?cate_id=37&page=1");
        }
        if (cate_id == 39) {
            $('.a-tab-03').addClass('on').siblings().removeClass('on');
            $('.nav-link').removeClass('on')
            $('.nav-link-02').addClass('on');
            $('.change_a').html("蜗牛民生").attr("href", "news-list.html?cate_id=39&page=1")
        }
        if (cate_id == 43) {
            $('.a-tab-04').addClass('on').siblings().removeClass('on');
            $('.nav-link').removeClass('on')
            $('.nav-link-03').addClass('on');
            $('.change_a').html("蜗牛农田").attr("href", "news-list.html?cate_id=43&page=1")
        }

    },
    // 新闻详情
    newsInfo: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });

        // 部分文章添加下载按钮跳转功能
        filterData = jsonDataId.filter(item => item.id == id);
        // console.log(filterData);
        if (filterData.length !== 0) {
            var dlPic = filterData[0].picture;
            var dlBtn = filterData[0].downloadBtn;
            var dlUrl = filterData[0].downloadUrl;
            $('.news-det .news-dl-image').show().css('background-image', dlPic);
            $('.news-det .news-dl-box').show().css('background-image', dlBtn);
            $('.news-det .news-download-btn').attr('href', dlUrl);
        }
        $.ajax({
            url: "https://api.qcplay.com/web/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                $('.news-det .main').addClass('main-show');
                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    $('.news .news-title h3, .current-title').html(newsTitle);
                    $('.news .origin').html(origin);
                    $('.news .created_at').html(created_at);
                    $('.details-info iframe').attr('src', 'news-iframe.html?id=' + id);

                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    // 获取当前ifname子页面的高度
                    function iframeAutoFit(iframeObj) {
                        setTimeout(function() {
                            if (!iframeObj) return;
                            iframeObj.height = (iframeObj.Document ? iframeObj.Document.body.scrollHeight + 20 : iframeObj.contentDocument.body.offsetHeight + 20)
                        }, 200)
                    }
                    $('#external-frame').load(function() { //  等iframe加载完毕             
                        iframeAutoFit(document.getElementById('external-frame'));
                        layer.close(index);
                        $("#external-frame").contents().find('.iframe').append(json.data.list.article_content);
                    });

                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '='
            // console.log(href)
            // console.log(lastPage);
            // console.log(nextPage);

        if (lastPage !== '') $('.prev-page').addClass('show').attr('href', href + lastPage.id).attr('title', lastPage.article_title);
        if (nextPage !== '') $('.next-page').addClass('show').attr('href', href + nextPage.id).attr('title', nextPage.article_title);
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    indexBind: function() {
        $('#share-2').share({ sites: ['qzone', 'qq', 'weibo', 'wechat'] });

        $.ajax({
            url: "https://api.qcplay.com/snail/pay/number?id=33",
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    $('.number-data').html(json.data.number);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
                layer.close(index);
            }
        })

        //适龄弹窗
        $('.year_box').on('click', function(event) {
            $('.year_pop').fadeIn();
        });
        $('.close-btn').click(function(event) {
            $('.year_pop').fadeOut();
        });
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '最强蜗牛', // 分享标题
                            desc: '公益活动', // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '最强蜗牛-公益活动', // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '最强蜗牛', // 分享标题
                            summary: '公益活动', // 分享内容
                            pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
                            url: window.location.href, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
}